import Model from "~/models/_Model";
import Room from "~/models/leyden-mobile/Room";

export default class Building extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/leydenmobile";
  }

  // Set the resource route of the model
  resource() {
    return "buildings";
  }

  primaryKey() {
    return "BUILDING";
  }

  relations() {
    return {
      //student: Student,
    };
  }

  rooms() {
    return this.hasMany(Room);
  }

  /**
   * Helper Methods
   */

  /**
   * Helper Attributes
   */
}
